import { useProductChangedAlert } from "./index";
import { usePermissionTableAlerts } from "./usePermissionTableAlerts";

export const PermissionChangeWatcher = () => {
  usePermissionTableAlerts(useProductChangedAlert());
  return null;
};
